var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isClose)?_c('div',[_c('keep-alive',[_c(_vm.componentName,_vm._b({tag:"component",on:{"close":_vm.closePopup,"cancel":_vm.closePopup,"showAuthModal":_vm.showAuthModal,"carouselChange":_vm.carouselChange}},'component',_vm.componentData,false))],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }